import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Logo from './Logo';
import { contactInfo } from '../mock';
import { trackSocialClick } from '../lib/analytics';
import { openCookieSettings } from './CookieConsent';

const SocialBadge = ({ children, href, onClick }) => {
  const Tag = href ? 'a' : 'span';
  return (
    <Tag
      href={href}
      target={href ? '_blank' : undefined}
      rel={href ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      className="w-[34px] h-[34px] rounded-full border flex items-center justify-center text-[13px] font-bold cursor-pointer transition-all no-underline"
      style={{ borderColor: 'rgba(255,255,255,.22)', color: '#c9c3b6' }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#e08e0b';
        e.currentTarget.style.color = '#e08e0b';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(255,255,255,.22)';
        e.currentTarget.style.color = '#c9c3b6';
      }}
    >
      {children}
    </Tag>
  );
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', to: '/' },
    { label: 'About Us', to: '/about-us' },
    { label: 'Partnership With Us', to: '/partnership/agency' },
    { label: 'Available Jobs', to: '/jobs' },
    { label: 'How It Works', to: '/#how-it-works' },
  ];

  return (
    <footer style={{ background: '#2d2a24', color: '#fff' }}>
      <div className="mx-auto max-w-7xl px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-12">
          <div className="space-y-4">
            <h3 className="m-0">
              <Logo markSize={32} wordmarkSize={24} ink="#fff" fill="transparent" />
            </h3>
            <p className="text-sm leading-relaxed" style={{ color: '#b4ae9f' }}>
              Your gateway to career opportunities in India &amp; Europe. We connect talent with employers across
              multiple countries.
            </p>
            <div className="flex gap-2.5 pt-1">
              <SocialBadge href="https://www.facebook.com/share/193VmWsNKH/" onClick={() => trackSocialClick('facebook')}>f</SocialBadge>
              <SocialBadge href="https://x.com/Zeevogo" onClick={() => trackSocialClick('x')}>X</SocialBadge>
              <SocialBadge href="https://www.linkedin.com/company/zeevogo/" onClick={() => trackSocialClick('linkedin')}>in</SocialBadge>
              <SocialBadge href="https://www.instagram.com/zeevogo/" onClick={() => trackSocialClick('instagram')}>IG</SocialBadge>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3 list-none p-0 m-0">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm no-underline transition-colors"
                    style={{ color: '#b4ae9f' }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = '#b4ae9f')}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Locations</h4>
            <ul className="space-y-3 list-none p-0 m-0">
              {['India', 'Poland', 'Romania', 'Croatia', 'Germany (Coming Q3 2026)', 'Spain (Coming Q4 2026)'].map(
                (loc) => (
                  <li key={loc} className="text-sm" style={{ color: '#b4ae9f' }}>
                    {loc}
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-4 list-none p-0 m-0">
              <li>
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="flex items-start gap-3 no-underline transition-colors"
                  style={{ color: '#b4ae9f' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#b4ae9f')}
                >
                  <Icon name="phone" size={16} style={{ marginTop: 2 }} />
                  <span className="text-sm">{contactInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-start gap-3 no-underline transition-colors"
                  style={{ color: '#b4ae9f' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#b4ae9f')}
                >
                  <Icon name="mail" size={16} style={{ marginTop: 2 }} />
                  <span className="text-sm break-all">{contactInfo.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3" style={{ color: '#b4ae9f' }}>
                <Icon name="pin" size={16} style={{ marginTop: 2 }} />
                <span className="text-sm">India</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t flex flex-col md:flex-row items-center md:items-start justify-between gap-3" style={{ borderColor: '#3a362e' }}>
          <p className="text-sm text-center md:text-left m-0" style={{ color: '#b4ae9f' }}>
            © {currentYear} Zeevogo
            <br />
            All rights reserved.
          </p>
          <button
            type="button"
            onClick={openCookieSettings}
            className="text-sm bg-transparent border-0 p-0 underline cursor-pointer"
            style={{ color: '#b4ae9f' }}
          >
            Cookie settings
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
